export default "__VITE_ASSET__CEZSnvYM__"